export default "__VITE_ASSET__6f71c14c__"